import type { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import {
    faAirConditioner,
    faBabyCarriage,
    faBadgeCheck,
    faBreadSlice,
    faCalendar,
    faCarRear,
    faCartShopping,
    faCircleParking,
    faCouch,
    faDumbbell,
    faElevator,
    faFlagSwallowtail,
    faGamepadModern,
    faHeat,
    faHotel,
    faHotTubPerson,
    faMugHot,
    faPhoneFlip,
    faPhoneOffice,
    faPinata,
    faPlane,
    faPlateUtensils,
    faPool8Ball,
    faPrint,
    faPuzzlePiece,
    faRouter,
    faShirt,
    faSink,
    faSpa,
    faTaxi,
    faTicket,
    faTreeDeciduous,
    faUserHeadset,
    faVanShuttle,
    faWashingMachine,
    faWaterLadder,
    faWheelchair,
    faWifi,
} from '@fortawesome/pro-regular-svg-icons';

export type HotelAmenity = {
    id: string | number;
    title: string;
    icon: IconDefinition;
};

export interface HotelCommentView {
    customer?: string | null;
    postedOn?: string;
    comment?: string | null;
    reserved?: boolean;
    rating: number | null;
}

export const amenityIconMapper = (hex: string): IconDefinition => {
    switch (hex) {
        case 'e9c2':
            return faCalendar;
        case 'e998':
            return faGamepadModern;
        case 'e98a':
            return faPlateUtensils;
        case 'e993':
            return faWaterLadder;
        case 'e9a2':
            return faWheelchair;
        case 'e982':
            return faPinata;
        case 'e97e':
        case 'e984':
            return faBabyCarriage;
        case 'e992':
            return faSpa;
        case 'e991':
            return faCouch;
        case 'e9a1':
            return faHotTubPerson;
        case 'e983':
            return faSink;
        case 'e9a5':
            return faPlane;
        case 'e9aa':
            return faBadgeCheck;
        case 'e997':
            return faShirt;
        case 'e995':
            return faPhoneOffice;
        case 'e986':
            return faMugHot;
        case 'e980':
            return faPool8Ball;
        case 'e9a8':
            return faTreeDeciduous;
        case 'e994':
            return faTaxi;
        case 'e98b':
            return faPhoneFlip;
        case 'e981':
            return faUserHeadset;
        case 'e985':
            return faVanShuttle;
        case 'e9a9':
            return faBreadSlice;
        case 'e9a3':
            return faDumbbell;
        case 'e98e':
            return faRouter;
        case 'e988':
            return faFlagSwallowtail;
        case 'e98c':
            return faPrint;
        case 'e9a6':
            return faCarRear;
        case 'e98d':
            return faPuzzlePiece;
        case 'e98f':
            return faCartShopping;
        case 'e996':
            return faTicket;
        case 'e987':
            return faElevator;
        case 'e9a7':
            return faHeat;
        // eslint-disable-next-line no-tabs
        case 'e9ab	':
        case 'e9ab':
            return faCircleParking;
        case 'e999':
            return faWifi;
        case 'e97d':
            return faAirConditioner;
        case 'e9a4':
            return faWashingMachine;
        default:
            return faHotel;
    }
};
